export const COMPLETED_CYCLE_VISIT_STATUS: string[] = ["VNU", "VNA", "VA"];
